export default {
  state: {
    guideList: []
  },
  mutations: {
    setOrderGuildList (state, guideList) {
      state.guideList = guideList
    }
  },
  actions: {
    handleOrderGuildList ({commit}, guideList) {
      commit('setOrderGuildList', guideList)
    },
  }
}
